module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pages/Dashboard/AdminDashboardPages/System settings/payment/payment.component.scss
// module id = ./src/app/home/pages/Dashboard/AdminDashboardPages/System settings/payment/payment.component.scss
// module chunks = main